import React from 'react';
import Box from '@mui/material/Box';

const containerStyles = {
  /* eslint-disable-next-line */
  bgcolor: 'surface.light',
  mt: { md: 6, xs: 0 },
  pb: { md: 0, xs: 8 },
  pl: { md: 37.5, xs: 1 },
  pr: { md: 0, xs: 1 },
};

const ViewLoadsPlanDetailsByDriver = () => {
  return <Box sx={containerStyles}>Loads Plan</Box>;
};

ViewLoadsPlanDetailsByDriver.propTypes = {};

export default ViewLoadsPlanDetailsByDriver;
